import { DateTime } from 'luxon';
import { useSelector } from 'react-redux';
import moment from 'moment';

import { getCurrentUser } from 'src/selectors/userSelectors';

export const useFormatDateTime = () => {
  const { localTimezone } = useSelector(getCurrentUser);

  return (dateTime: string) => {
    return `${DateTime.fromISO(dateTime)
      .setZone(localTimezone)
      .toFormat('dd MMMM yyyy, hh:mm a')} ${moment
      .tz(localTimezone)
      .zoneAbbr()} (UTC ${DateTime.local().setZone(localTimezone).toFormat('ZZ')})`;
  };
};
